import { PageHeader } from '@fukuri-admins/ui/common';
import { getClientContractListLink } from '~/utils/getLinks';

type Props = {
  /**
   * パンくずに表示する利用企業名
   *
   * 「{clientName}の契約期間の編集」形式で最後のパンくず要素に使用する
   */
  clientName: string;
};

/**
 * 企業契約期間 編集ヘッダー Presentation コンポーネント
 *
 * breadcrumb: 企業契約期間 → {利用企業名}の契約期間の編集
 *
 * - PartnerAdmin は自パートナー前提のため、パートナー名のパンくずは不要（2 階層のみ）
 * - 契約プラン情報（プラン名・種別等）は表示しない（本体側の表示は T03 の担当）
 */
export const EditClientContractTermHeaderPresentation: React.FC<Props> = ({ clientName }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[
      { label: '企業契約期間', href: getClientContractListLink() },
      { label: `${clientName}の契約期間の編集` },
    ]}
  />
);
